// extracted by mini-css-extract-plugin
export default {"divider":"Spacer-module_divider__Hobh6"};